import * as React from 'react'
import { StyledSectionContainer, ModuleContentContainer, SecondaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const CountryModule = ({ links }) => (
  <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
    <SecondaryTitle data-testid="secondary-title-pp">
      Immobilier <b>à {"l'étranger"}</b>
    </SecondaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <LinkList links={links} wording={{ plural: 'pays' }} maxLinks={10} />
    </ModuleContentContainer>
  </StyledSectionContainer>
)

export default CountryModule
